import React from 'react'
import { Alert, DialogRef } from '../../Feedback'
import { GalleryItemModel } from './Gallery.model'
import GallerySlider from './GallerySlider'
import GalleryImage from './GalleryImage'

type GalleryDialogProps = {
    dialogRef: React.Ref<DialogRef>
    items?: GalleryItemModel[]
}

const GalleryDialog = ({ dialogRef, items }: GalleryDialogProps) => {
    return (
        <Alert
            cancelText=""
            submitText=""
            title=""
            ref={dialogRef}
            size='sm'
        >
            {
                items?.length === 1 ?
                    <GalleryImage {...items[0]} /> : 
                    <GallerySlider items={items} />
            }

        </Alert>
    )
}

export default GalleryDialog